import { ReactNode, useEffect } from "react";

import { AntLayout } from "./styledComponents";
import LeftNavigation from "./LeftNavigation";
import api from "../../../api";
import useEmailParam from "../../hooks/useEmailParam";
import { useAuth } from "@/modules/auth";

const PageWrapperWithNavigation = (props: { children: ReactNode }) => {
  const [emailParam] = useEmailParam();
  const { operator } = useAuth();
  useEffect(() => {
    document.title = "Backoffice";
    const fetchData = async () => {
      if (emailParam) {
        const user = await api.kontax.getUserByEmail(emailParam);
        if (user) {
          document.title = `${user.firstName} ${user.lastName}`;
        }
      }
    };

    fetchData().catch(() => {}); // ignore "User not found"
  }, [emailParam]);

  return (
    <AntLayout hasSider>
      {operator && <LeftNavigation />}
      {props.children}
    </AntLayout>
  );
};

export default PageWrapperWithNavigation;
